import { Route, Routes } from 'react-router-dom'
import Brett from 'subdomains/Brett'

export const brettRoutes = {
  subdomain: 'brett',
  routes: () => (
    <Routes>
      <Route path='/' element={<Brett />} />
    </Routes>
  ),
}
